import React, { useState } from 'react';
import { GoogleMap, Marker, useLoadScript, Polygon } from '@react-google-maps/api';

interface MapWithPolygonProps {
  latPoint: number;
  lngPoint: number;
  lat: number;
  lng: number;
}

const  MapWithPolygon: React.FC<MapWithPolygonProps> = ({ latPoint, lngPoint, lat, lng }) => {

  const urlMan = 'https://maps.google.com/mapfiles/ms/micons/man.png'; // URL del icono de persona

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCWNPjJL2-d8AN8bHviq12ci1H5EXG4fsg",
  });

  const circleOptions: google.maps.PolygonOptions = {
    fillColor: '#0096D6', // Color del polígono
    fillOpacity: 0.35,
    strokeWeight: 0,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: true,
    zIndex: 1,
  };

  // Función para calcular los puntos del polígono
  const calculatePolygonPoints = (center: { lat: number; lng: number }, radius: number): google.maps.LatLngLiteral[] => {
    const points: google.maps.LatLngLiteral[] = [];
    const numberOfPoints = 50;
    const earthRadius = 6378.1; // Radio de la Tierra en kilómetros

    for (let i = 0; i < numberOfPoints; i++) {
      const angle = (i / numberOfPoints) * (2 * Math.PI);
      const latitude = center.lat + (radius / earthRadius) * (180 / Math.PI) * Math.sin(angle);
      const longitude = center.lng + (radius / earthRadius) * (180 / Math.PI) * Math.cos(angle) / Math.cos(center.lat * Math.PI / 180);
      points.push({ lat: latitude, lng: longitude });
    }
    return points;
  };

  const radius = 0.2; // Radio del polígono en kilómetros (200 metros en este caso)
  const polygonPoints = calculatePolygonPoints({ lat: latPoint, lng: lngPoint }, radius);

  return (
    <>
      {isLoaded && <GoogleMap
        zoom={15}
        center={{ lat: latPoint, lng: lngPoint}}
        mapContainerClassName="map-container"
      >
        <Marker position={{ lat: latPoint, lng: lngPoint }} />
        <Marker position={{ lat: lat, lng: lng }} icon={urlMan} />
        <Polygon
          path={polygonPoints}
          options={circleOptions}
        />

      </GoogleMap>}
    </>

  );
};

export default MapWithPolygon;